import { render } from "./gsrsu03030302.vue?vue&type=template&id=07aa8bd0&scoped=true"
import script from "./gsrsu03030302.vue?vue&type=script&lang=js"
export * from "./gsrsu03030302.vue?vue&type=script&lang=js"

import "./gsrsu03030302.vue?vue&type=style&index=0&id=07aa8bd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07aa8bd0"]])

export default __exports__